import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import {
    StreamInfo, ITopology, useGetConfigQuery, useGetTopologyQuery,
    useLazyGetMetricPrometheusQuery, useLazyGetWorkflowLogsQuery,
    useLazyStreamInfoOneWorkFlowQuery,
    StreamStatus
} from '../../app/apiSlice';
import "./OneWorkflow.scss";
import { classNames } from "primereact/utils";
import moment from "moment";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { Skeleton } from "primereact/skeleton";
import { Message } from "primereact/message";
import { TopBar } from "../../components/topBar/topBar";
import { TagEnv } from "../../components/environnement/tagEnv";
import { useSecureApplication } from "../../hooks/KeycloackConnection";
import { useAppSelector } from '../../hooks/hooks';
import { StartStopStream } from "../editor/topBar/stream-toolbar";
import { LogsDatas } from "../editor/logs/LogsDatas";

const LoadingForOneWorFlow = () => {
  return (
    <div className="ml-5 mr-5" style={{ width: "100%" }}>
      <Skeleton className="mt-7 mb-10" height="15vh" />
      <Skeleton className="mt-7 mb-10" height="20vh" />
      <Skeleton className="mt-7 mb-10" height="65vh" />
    </div>
  );
};

export const OneWorkflow = () => {
  // @ts-ignore
  const {state: {topologyID, flowID}} = useLocation();
  const [pageNumber, setPageNumber] = useState(1);
  const lastVersionName = useAppSelector((state) => state.app.config.lastVersionName);
  const {data: topology} = useGetTopologyQuery({id: topologyID, version: lastVersionName});
  const [getStreamByName, { data: streamInfo, ...status }] =
    useLazyStreamInfoOneWorkFlowQuery();
  const [getWorkflowLogs, { data: workflowLogs, ...logStatus }] =
      useLazyGetWorkflowLogsQuery();
  const [getMetrics, { data: prometheus, ...statusPrometheus }] =
    useLazyGetMetricPrometheusQuery();
  const {t: translate } = useTranslation();
  const {data : config} = useGetConfigQuery();
  const [prometheusData, setPrometheusData] = useState<Map<string, string|number>>();
  const { hasAnyPerm } = useSecureApplication();

  useEffect(() => {
    if (streamInfo && streamInfo.status && (streamInfo.status !== StreamStatus.ERROR && streamInfo.status !== StreamStatus.RUNNING)&& topologyID && flowID && pageNumber) {
      getWorkflowLogs({workflowID: flowID, pageNumber: pageNumber.toString(), topologyId: topologyID });
    }
  }, [streamInfo, topologyID, flowID, pageNumber]);

  useEffect(() => {
    if (topologyID && topology) {
      getStreamByName({ topologyid: topologyID, flowid: flowID, env: topology.environnement });
    }
  }, [topology]);

  useEffect(() => {
    if (streamInfo?.name && topology) {
      getMetrics({ flowName: streamInfo?.name, env: topology.environnement });
    }
  }, [streamInfo]);

  useEffect(() => {
    if (config?.metricList && prometheus?.metrics && prometheus?.metrics.length > 0) {
      const mapLabelValue = new Map<string, string|number>();
      prometheus.metrics.forEach(metric => {
        if (config.metricList.includes(metric.name) && metric.vector && metric.vector[0]?.value !== undefined) {
          mapLabelValue.set(metric.name, metric.vector[0].value);
        }
      });
      setPrometheusData(mapLabelValue);
    }
  }, [prometheus]);

  const TopBarLeftComponent = (flowName: string | undefined) => {
    return (
      <div className="flex align-items-center">
        <div className="mr-2" style={{ color: "#6c757d" }}>
          Flux
        </div>{" "}
        <i
          style={{ color: "#6c757d" }}
          className="pi pi-chevron-right mr-2"
        ></i>
        <b className="mr-2">{flowName} </b>
        {topology && <TagEnv code={topology.environnement} name={topology.environnement} />}
      </div>
    );
  };

  const positiveStatuses = ['Running', 'Success', 'Terminated'];
  const getstatuscolor = (status: string) => {
    return positiveStatuses.includes(status) ? 'green' : 'red';
  }

  const renderCard = (props: {
    icon: string;
    color: string;
    label: string;
    value: string | number;
  }) => {
    return (
      <div className="col-12 md:col-4 flex align-items-center">
        <div>
          <span className="p-1 inline-block">
            <i
              className={classNames("pi", "text-2xl", props.icon)}
              style={{ color: props.color }}
            />
          </span>
        </div>

        <div className={"p-2"}>
          <b>{props.label}</b> : {props.value}
        </div>
      </div>
    );
  };

  const PrometheusDisplay = () => {
      const prometheusDatas: JSX.Element[] = []
      prometheusData?.forEach((value: string|number, key: string) => {
          prometheusDatas.push(renderCard({
              icon: "",
              color: "",
              label: translate(`prometheus.${key}`),
              value: value
          }))
      });

      return prometheusDatas.length > 0 ? <div className="grid">{prometheusDatas}</div> : <></>;
  }

  const copyToClipboard = () => {
    if (workflowLogs.transcode_click_house) {
        const anyarrayclickhouse = workflowLogs.transcode_click_house as any[];
        const logs = anyarrayclickhouse.map((log) => log.message).join("\n");
        navigator.clipboard.writeText(logs);
    } else {
        navigator.clipboard.writeText(translate("flow_logs.logs.not_available"));
    }
};

  const LogsDisplay = () => {
      const handleNextPage = () => {
          setPageNumber(prevPage => prevPage + 1);
      };

      const handlePrevPage = () => {
          setPageNumber(prevPage => (prevPage > 1 ? prevPage - 1 : 1));
      };

      const logRows: JSX.Element[] = [];

      const anyarrayclickhouse = workflowLogs.transcode_click_house as any[];
      anyarrayclickhouse?.map((log, index) => {
            let line = log.message;
            let className = 'block';
            if (line.startsWith('\tat')) {
              className = 'tab';
              line = line.substring(4, line.length);
            }
            logRows.push(<div key={index} className={className}>{line}</div>);
       })
      var numberofpage = Math.floor(workflowLogs.total_result_number/workflowLogs.number_per_page);
      numberofpage = workflowLogs.total_result_number % workflowLogs.number_per_page > 0 ? numberofpage++ : numberofpage;

      return <div className="flex-1 flex-column bg-white">
          <div className={'header'}>
              <h3>{translate('flow_logs.logs.title')}</h3>
              <Button
                  onClick={() => {
                      copyToClipboard()
                  }}
                  label={translate('flow_logs.logs.copy')}
                  icon="pi pi-copy"
                  className="p-button-text"
              />
          </div>
          {logStatus.status === "pending" ? (
            <div className="loading-container">
              <Button icon="pi pi-spin pi-spinner" disabled className="p-button-rounded p-button-text"/>
            </div>
          ) : (
            <div className="logs-container bg-white">{logRows}</div>
          )}
          <div className="flex-1 p-4">
            <div className="flex flex-column align-items-center">
              <div className="flex align-items-center">
                <Button
                  icon="pi pi-chevron-left"
                  onClick={handlePrevPage}
                  disabled={pageNumber <= 1 || logStatus.status === "pending"}
                  className="p-button-rounded p-button-text"
                />
                <span className="text-lg font-semibold">{pageNumber}</span>
                <Button
                  icon="pi pi-chevron-right"
                  onClick={handleNextPage}
                  disabled={pageNumber > numberofpage || logStatus.status === "pending"}
                  className="p-button-rounded p-button-text"
                />
              </div>
            </div>
          </div>
      </div>;
  }

    return (
        <>
            {streamInfo && (
                <>
                    <TopBar
                        left={TopBarLeftComponent(streamInfo.name)}
                        right={<TopBarRightComponont stream={streamInfo} topology={topology!}/>}/>
                    <div className="p-2 cardWorkflow">
                        <div className="grid">
                            {renderCard({
                                icon: 'pi-calendar-times',
                                color: '',
                                label: translate('label.creation'),
                                value: moment(streamInfo.start_time).format('lll'),
                      })}
                      {streamInfo.close_time && renderCard({
                          icon: 'pi-calendar-times',
                          color: '',
                          label: translate('label.change'),
                          value: moment(streamInfo.close_time).format(
                              'lll'
                          ),
                      })}

                      {renderCard({
                          icon: 'pi-info-circle',
                          color: getstatuscolor(streamInfo.status),
                          label: translate('label.status'),
                          value: streamInfo.status,
                      })}
                  </div>
                  {prometheusData && <PrometheusDisplay/>}
              </div>
              <div className="one-workflow-console-container ">
                { (streamInfo.status === StreamStatus.ERROR || streamInfo.status === StreamStatus.RUNNING) &&
                  <LogsDatas
                    streamNameAndRunID={{name: flowID, runID: streamInfo.run_id, topologyId: topologyID}}
                    env={streamInfo.environnement}
                  />
                }
                { (streamInfo.status !== StreamStatus.ERROR && streamInfo.status !== StreamStatus.RUNNING) &&
                  <>
                  { logStatus.isLoading ? <LoadingForOneWorFlow/> : logStatus.isError ?
                    <div className="m-5" style={{width: '100%'}}>
                        <Message style={{width: '100%'}} severity="error"
                            text="Erreur lors de la récupération des logs" />
                    </div> :
                    workflowLogs && hasAnyPerm('flows.all', 'flows_teclogs') ? <LogsDisplay/> :
                        <Message style={{width: '100%'}} severity="info"
                                 text="Pas de logs disponibles" />
                  }
                  </>
                }
              </div>
              </>
            )}

            {status.isLoading ? <LoadingForOneWorFlow/> :
                (!topologyID || !streamInfo || status.isError) &&
            <div className="m-5" style={{width: '100%'}}>
                <Message
                    style={{width: "100%"}}
                    severity="error"
                    text="Flux non trouvé"
                />
            </div>
        }
    </>
  );
};

const TopBarRightComponont = ({stream, topology}: { stream: StreamInfo, topology: ITopology }) => {

    const navigate = useNavigate();

    return (
        <div className="flex align-items-center">
            <Button
                size="small"
                label="Ouvrir dans l'éditeur"
                style={{height: "O.5rem", marginRight: "1rem"}}
                className={"p-button-text"}
                disabled={!stream?.name}
                onClick={() => {
                    navigate(`/treatments/editor?t=${stream?.name}&v=${topology.version}`)
                }}
            />
            <StartStopStream topology={topology} onlyStop={true}/>
        </div>
    );
};
